import { useEffect } from 'react'

const useOnClickOutside = (ref, callback) => {
  const handleClickOutside = (event) => {
    const { current } = ref ?? {}
    if (!current) {
      return
    }

    if (typeof current.contains === 'function' && !current.contains(event.target)) {
      callback(event)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [callback])
}

export default useOnClickOutside
